export const PER_PAGE = 24;
